"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.tagging-utils");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.html-utils");

require("./LinkOverBox.scss");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stateless component to draw a card.
 * @param {string} link Link url
 * @param {string} wrapperClass css class
 * @param {func} onClick Executed function by clicking the link.
 * @param {string} managementValue If link trigger a management action
 * @param {string} id Link id used to get the taggingId
 * @param {string} target Link target used when link is an externalLink
 * @param {string} alt Alt value for link accesibility
 * @param {string} label Label on the button.
 * @param {string} component String that indicates the component which use LinkOverBox (used for tagging)
 * @param {jsxNode} children Components that would be inside of Link
 * @returns {JSX} Component JSX.
 */
var LinkOverBox = function LinkOverBox(_ref) {
  var link = _ref.link,
      wrapperClass = _ref.wrapperClass,
      onClick = _ref.onClick,
      managementValue = _ref.managementValue,
      id = _ref.id,
      alt = _ref.alt,
      label = _ref.label,
      component = _ref.component,
      children = _ref.children,
      match = _ref.match;
  // Get pagename for every project
  var pageName = window.location.href.replace(window.location.hostname, '').replace(window.location.pathname, '').replace(window.location.protocol, '').replace('//#', '');

  if (match && match.params) {
    Object.keys(match.params).forEach(function (paramKey) {
      var paramValue = _this.props.match.params[paramKey];
      pageName = pageName.replace("/".concat(paramValue), '');
    });
  }

  pageName = pageName.replace(/\//g, '-'); // Build taggingId using id and component (from props) and pageName

  var taggingId = "".concat(id).concat(pageName, "-").concat(component);
  var taggingType = 'enlace'; // Handle click for link

  var handleOnClick = function handleOnClick() {
    if (taggingType && taggingId && id) {
      (0, _gerenciatdUtils.sendTagging)(taggingType, taggingId, managementValue);
    }

    if (onClick) {
      onClick();
    }
  };

  if (link) {
    var externalInfo = (0, _gerenciatdUtils2.externalLink)(link);

    if (externalInfo.spaExternal || externalInfo.siteExternal) {
      var target = externalInfo.siteExternal ? '_blank' : '_self';
      return _react.default.createElement("a", {
        "aria-label": label,
        id: id,
        onClick: handleOnClick,
        alt: alt,
        href: link,
        rel: "noopener noreferrer",
        target: target,
        className: "linkOverBox ".concat(wrapperClass)
      }, label || children);
    } else {
      return _react.default.createElement(_reactRouterDom.Link, {
        "aria-label": label,
        id: id,
        onClick: handleOnClick,
        className: "linkOverBox ".concat(wrapperClass),
        to: link,
        alt: alt
      }, label || children);
    }
  }

  return null;
};

LinkOverBox.propTypes = {
  link: _propTypes.default.string.isRequired,
  alt: _propTypes.default.string,
  wrapperClass: _propTypes.default.string,
  onClick: _propTypes.default.func,
  managementValue: _propTypes.default.string,
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  component: _propTypes.default.string,
  children: _propTypes.default.node,
  match: _propTypes.default.object
};
LinkOverBox.defaultProps = {
  wrapperClass: '',
  alt: '',
  onClick: function onClick() {},
  managementValue: null,
  id: '',
  label: '',
  component: '',
  children: null,
  match: {}
};
var _default = LinkOverBox;
exports.default = _default;

//# sourceMappingURL=index.js.map